import _ from 'lodash';

export default angular.module('cian.newbuild.limitNumber', [])
  .directive('cianLimitNumber', () => {
    return {
      require: 'ngModel',
      link: (scope, element, attrs, ngModelCtrl) => {
        const config = {
          min: 1,
          max: Number.MAX_VALUE,
        };
        _.extend(config, scope.$eval(attrs.cianLimitNumber));

        // Разрешаем ввод только цифр
        element.bind('keypress', event => {
          if (event.charCode) return /\d/.test(String.fromCharCode(event.charCode))
        });

        /**
         * В отличие от обычного Number конвертируем пустую строку в NaN
         * @param {string} str
         * @return {number}
         */
        const convertToNumber = str => str === '' ? NaN : Number(str);

        /**
         * @param {number} value
         * @return {number}
         */
        const limitValue = value => {
          if (_.isNumber(value) && !_.isNaN(value)) {
            return Math.min(Math.max(value, config.min), config.max);
          }
          return config.defaultValue;
        };

        ngModelCtrl.$parsers.unshift(value => {
          const limitedValue = limitValue(convertToNumber(value));

          // Пришла строка - возвращаем строку
          const viewValue = angular.isDefined(limitedValue) ?
            limitedValue.toString() :
            // null в инпуте превращается в 0, поэтому именно undefined
            undefined;

          ngModelCtrl.$setViewValue(viewValue);
          element.val(viewValue || '');
          return viewValue;
        });
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/serp/directives/limit-number.dir.js